import { useOutletContext, useParams } from "react-router-dom";
import { useMe } from "@/api/hooks/auth";
import type { ProjectOut } from "@/api/hooks/projects";

export type Role = "owner" | "member" | "staff" | null;

export type ProjectContext = { project: ProjectOut; org: string; projectSlug: string; role: Role };

export function useProjectContext(): ProjectContext {
  return useOutletContext<ProjectContext>();
}

/** Route params for pages under `/:org/:project`. */
export function useProjectParams(): { org: string; project: string } {
  const { org = "", project = "" } = useParams();
  return { org, project };
}

/** The current user's role in an organisation, `staff` for Codemonk staff. */
export function useOrgRole(orgSlug: string): Role {
  const me = useMe();
  if (!me.data) return null;
  if (me.data.is_staff) return "staff";
  return me.data.memberships.find((m) => m.organisation_slug === orgSlug)?.role ?? null;
}

export function canManage(role: Role): boolean {
  return role === "owner" || role === "staff";
}
